<app-simple-responsive-frame>
    <div class="review-grid">
        <!-- Preview de la propiedad -->
        <div class="review-card-col">
            <app-property-card
                *ngIf="cardVm"
                [vm]="cardVm"
                (select)="previewProperty($event)"
                class="clickable">
            </app-property-card>
            <p-skeleton *ngIf="loading" width="320px" height="420px" borderRadius="16px"></p-skeleton>
            <p *ngIf="!loading && !cardVm" class="no-card">No pudimos cargar la vista previa de tu propiedad.</p>
        </div>

        <!-- Qué sigue -->
        <div class="review-text-col">
            <h2>¡Listo! Es hora de publicar.</h2>
            <p class="lead">
                Esto es lo que el público podrá ver de tu {{ segmentLabel?.toLowerCase() }}.<br>
                Dale una revisada y asegúrate que todo esté correcto.
            </p>

            <h3>¿Qué sigue?</h3>

            <div class="next-step">
                <h4>Aprobación de tu publicación</h4>
                <p>
                    Revisaremos lo que subiste y te avisaremos si está todo bien.<br>
                    Si sí, se publicará automáticamente.<br>
                    Si falta algo, te diremos qué corregir antes de publicarlo.
                </p>
            </div>

            <div class="next-step">
                <h4>Compartir tu publicación</h4>
                <p>
                    ¡A difundir tu anuncio!<br>
                    Comparte tu anuncio en redes para encontrar a la persona adecuada más rápido.
                </p>
            </div>

            <div class="next-step">
                <h4>Recibe personas interesadas</h4>
                <p>
                    Las personas interesadas podrán contactarte a través de Tadic List.<br>
                    Tú decides si compartes tus datos con ellos para la negociación.<br>
                    Recuerda que no gestionamos el trato; tú decides cómo proceder para cerrarlo.
                </p>
            </div>
        </div>
    </div>

    <app-page-navigation-bar
        [value]="98"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="currentMode"
        [stepKey]="'review'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()"
        (saveAndExit)="handleSaveAndExit()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>
